import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const CurrencyYen = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25.805 3.591C25.927 3.425 26 3.221 26 3C26 2.448 25.552 2 25 2C24.676 2 24.389 2.155 24.207 2.393C24.205 2.395 16 13.333 16 13.333C16 13.333 7.796 2.395 7.793 2.393C7.61 2.154 7.323 2 7 2C6.448 2 6 2.448 6 3C6 3.222 6.073 3.426 6.195 3.591C6.197 3.594 14 14 14 14H9C8.448 14 8 14.448 8 15C8 15.552 8.448 16 9 16H15V20H9C8.448 20 8 20.448 8 21C8 21.552 8.448 22 9 22H15V29C15 29.552 15.448 30 16 30C16.552 30 17 29.552 17 29V22H23C23.552 22 24 21.552 24 21C24 20.448 23.552 20 23 20H17V16H23C23.552 16 24 15.552 24 15C24 14.448 23.552 14 23 14H18C18 14 25.803 3.594 25.805 3.591V3.591Z" />
	</svg>
);

export default CurrencyYen;
